import React, { useState, useEffect } from 'react';
import {
    Layout,
    Select,
    Input,
    Button,
    Table,
    Modal,
    message,
    Form, Col, Row, AutoComplete,
} from 'antd';
import axios from 'axios';
import {copyToClipboard, fetchTokenOptions, formattedAddress, formatTimestamp} from "../../util";

const { Content } = Layout;
const { Option } = Select;

const BatchTransferIn = () => {
    const [walletGroups, setWalletGroups] = useState([]);
    const [records, setRecords] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
    const [loading, setLoading] = useState(false);
    const [detailModalVisible, setDetailModalVisible] = useState(false);
    const [detailTransfers, setDetailTransfers] = useState([]);
    const [form] = Form.useForm();
    const [chains, setChains] = useState([]);  // 新增：存储链的列表
    const [selectedChain, setSelectedChain] = useState(null);  // 新增：选中的链
    const [tokenAddress, setTokenAddress] = useState("");  // 新增：存储Token地址
    const [detailPagination, setDetailPagination] = useState({ current: 1, pageSize: 10, total: 0 });
    const [selectedTaskId, setSelectedTaskId] = useState(null); // 新增：存储当前查看详情的任务ID
    const [transferType, setTransferType] = useState('CEX_FAST'); // 添加 transferType 状态
    const [tokenOptions, setTokenOptions] = useState({});

    useEffect(() => {
        fetchWalletGroups();
        fetchRecords();
        fetchChains(); // 获取链的列表
    }, []);

    const fetchChains = async () => {
        try {
            const response = await axios.get('/api/v1/chain/list');
            if (response.data.code === 0) {
                setChains(Object.values(response.data.data));  // 提取链的列表
            } else {
                message.error(response.data.msg);
            }
        } catch(error) {
            message.error(error);
        }

    };
    useEffect(() => {
        const loadTokenOptions = async () => {
            const data = await fetchTokenOptions();
            setTokenOptions(data);
        };

        loadTokenOptions();
    }, []);

    const fetchWalletGroups = async (name = '') => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/wallet/list', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: { name, page: 1, size: 20 },
            });
            if (response.data.code === 0) {
                setWalletGroups(response.data.data.items);
            } else {
                if(response.data.code === -5) {
                    console.log("token 过期")
                    message.error('token 过期');
                    navigate('/login');
                } else {
                    message.error(response.data.msg);
                }
            }
        } catch(error) {
            message.error(error);
        }
    };

    const createBatchTransfer = async (values) => {
        setLoading(true);

        const payload = {
            group_id: values.group_id,
            type: values.type,
            total_amount: values.total_amount,
            duration_minutes: parseInt(values.duration_minutes, 10),
            chain_id: selectedChain?.chain_id || null, // 使用选中的链ID
            token_address: tokenAddress,
            chain_type: "evm", // 默认使用EVM链类型
            min_amount: values.min_amount ? values.min_amount: "0",
        };

        if (values.type.startsWith('CEX')) {
            payload.cex_api_key = values.cex_api_key;
            payload.cex_api_secret = values.cex_api_secret;
        }

        if (values.type.startsWith('DEX')) {
            payload.on_chain_private_key  = values.chain_private_key;
        }

        try {
            const token = localStorage.getItem('token');
            const response = await axios.post('/api/v1/transfers/deposit/create', payload,
                {
                    headers: {
                    Authorization: `Bearer ${token}`,
                    }
                });
            if (response.data.code === 0) {
                message.success('批量转入任务创建成功');
                fetchRecords();
            } else {
                handleError(response.data.code, response.data.msg);
            }
        } catch (error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleError = (code, data) => {
        switch (code) {
            case 3001:
                message.error('无效的转入类型');
                break;
            case 3002:
                message.error('API密钥验证失败');
                break;
            case 3003:
                message.error('余额不足');
                break;
            case -5:
                message.error('token 过期');
                navigate('/login');
            default:
                message.error(data);
                break;
        }
    };

    const fetchRecords = async (page = 1, size = 20) => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/transfers/deposit/list', {
                params: { page, size },
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.data.code === 0) {
                const { items, total } = response.data.data;
                setRecords(items);
                setPagination({ current: page, pageSize: size, total });
            } else {
                message.error('加载批量转入记录失败');
            }
        } catch(error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchTransferDetails = async (taskId, page = 1, size = 10) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/api/v1/transfers/deposit/info`, {
                params: {
                    task_id: taskId,
                    page,
                    size,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            if (response.data.code === 0) {
                setSelectedTaskId(taskId); // 记录当前任务ID，分页时复用
                setDetailTransfers(response.data.data.items || []);
                setDetailPagination({
                    current: page,
                    pageSize: size,
                    total: response.data.data.total_account_count, // 总数
                });
                setDetailModalVisible(true);
            } else {
                message.error(response.data.msg);
            }
        } catch(error) {
            message.error(error);
        }
    };

    // 处理代币地址变化
    const handleTokenAddressChange = (value) => {
        setTokenAddress(value);
    };


    const columns = [
        { title: '序号', dataIndex: 'index', render: (_, __, index) => index + 1 + (pagination.current - 1) * pagination.pageSize },
        { title: '钱包组', dataIndex: 'group_name' },
        { title: '代币地址', dataIndex: 'token_address',
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* 地址链接 */}
                    <a href={ `https://basescan.org/address/${text}`}
                       target="_blank"
                       rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>

                    {/* 复制按钮 */}
                    <Button
                        size="small"
                        onClick={() => copyToClipboard(text)}>
                        复制
                    </Button>
                </div>
            )
        },
        { title: '链', dataIndex: 'chain_id', render: (text) => {

            return chains.map((chain) => {
                if (chain.chain_id === text) {
                    return chain.chain_name;
                }
            });
            }
        },
        { title: '总金额', dataIndex: 'total_amount' },
        { title: '完成进度', dataIndex: 'progress', render: (_, record) => `${record.completed_account_count}/${record.total_account_count}` },
        { title: '开始时间', dataIndex: 'start_time', render: (timestamp) => formatTimestamp(timestamp) },
        { title: '预计结束时间', dataIndex: 'estimated_end_time', render: (timestamp) => formatTimestamp(timestamp) },
        {
            title: '操作',
            render: (_, record) => (
                <Button onClick={() => fetchTransferDetails(record.task_id)}>查看详情</Button>
            ),
        },
    ];

    const detailColumns = [
        { title: '序号', dataIndex: 'index', render: (_, __, index) => index + 1 + (detailPagination.current - 1) * detailPagination.pageSize },
        { title: '钱包地址', dataIndex: 'account_address',
            render: (text, record) => (

                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {text}
                    <Button
                        size="small"
                        onClick={() => copyToClipboard(text)}>
                        复制
                    </Button>
                </div>
            )
        },
        { title: '金额', dataIndex: 'amount' },
        { title: '状态', dataIndex: 'status',
            // render: (_, record) => record.status === 'COMPLETED' ?
            //     <a href={`https://sepolia.basescan.org/tx/${record.tx_hash}`} target="_blank" rel="noopener noreferrer">查看交易</a> : '未完成'
            render: (text, record) => {
                // 如果 scan_url 为空，则不显示超链接，直接显示地址
                if(record.status === 'COMPLETED') {
                    if (!record.scan_url) {
                        return <span>已完成</span>;
                    }

                    // 如果 scan_url 存在，则显示超链接
                    return (
                        <a href={record.scan_url} target="_blank" rel="noopener noreferrer">
                            查看交易
                        </a>
                    );
                } else {
                    return '未完成'
                }

            },
        },
    ];


    return (
        <Content style={{ padding: 20 }}>
            <Form
                form={form}
                layout="horizontal"
                onFinish={createBatchTransfer}
                style={{ marginBottom: 20 }}
            >
                {/* 第一行 */}
                <Row gutter={16} style={{ marginBottom: 10 }}>
                    <Col span={5}>
                        <Form.Item
                            name="group_id"
                            rules={[{ required: true, message: '请选择钱包组' }]}
                        >
                            <Select
                                        allowClear
                                showSearch
                                placeholder="选择钱包组"
                                onSearch={fetchWalletGroups}
                                style={{ width: '100%' }}
                            >
                                {walletGroups.map((group) => (
                                    <Option key={group.group_id} value={group.group_id}>
                                        {group.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={5}>
                        <Form.Item
                            name="type"
                            rules={[{ required: true, message: '请选择转入方式' }]}
                        >
                            <Select
                                        allowClear placeholder="转入方式" style={{ width: '100%' }}  onChange={(value) => {setTransferType(value); console.log(value);}}>
                                <Option value="CEX_FAST_MEXC">CEX-MEXC 快速转入</Option>
                                <Option value="CEX_SAFE_MEXC">CEX-MEXC 安全转入</Option>
                                <Option value="CEX_FAST_BINANCE">CEX-BINANCE 快速转入</Option>
                                <Option value="CEX_SAFE_BINANCE">CEX-BINANCE 安全转入</Option>
                                <Option value="DEX_FAST">DEX 快速转入</Option>
                                <Option value="DEX_SAFE">DEX 安全转入</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={5}>
                        <Form.Item
                            name="total_amount"
                            rules={[
                                { required: true, message: '请输入总金额' },
                                {
                                    validator: (_, value) =>
                                        value > 0 ? Promise.resolve() : Promise.reject(new Error('金额必须大于0')),
                                },
                            ]}
                        >
                            <Input placeholder="总金额" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={5}>
                        <Form.Item
                            name="min_amount"
                            rules={[
                                {
                                    validator: (_, value) => {
                                        // 验证是否为数字
                                        if (value && isNaN(value)) {
                                            return Promise.reject(new Error('请输入有效的数字'));
                                        }
                                        // 验证是否小于总金额
                                        if (value && parseFloat(value) >= 0 && parseFloat(value) >= parseFloat(form.getFieldValue('total_amount'))) {
                                            return Promise.reject(new Error('最小金额必须小于总金额'));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input placeholder="最小金额" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            name="chain_id"
                            rules={[{ required: true, message: '请选择链' }]}
                        >
                            <Select
                                allowClear
                                placeholder="选择链"
                                value={selectedChain?.chain_id}
                                onChange={(value) => {
                                    setSelectedChain(chains.find(chain => chain.chain_id === value));

                                    form.setFieldsValue({ token_address: ''}); // 更新表单值
                                }}
                                style={{ width: '100%' }}
                            >
                                {chains.map((chain) => (
                                    <Option key={chain.chain_id} value={chain.chain_id}>
                                        {chain.chain_name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                {/* 第二行 */}
                <Row gutter={16}>
                    <Col span={5}>
                        <Form.Item
                            name="token_address"
                            rules={[{ required: true, message: '请选择或输入代币地址' }]}
                            // style={{ flex: 1, minWidth: '180px' }}
                        >
                            {/*<Input*/}
                            {/*    placeholder="Token地址,0x00开头"*/}
                            {/*    value={tokenAddress}*/}
                            {/*    onChange={(e) => setTokenAddress(e.target.value)}*/}
                            {/*    style={{ width: '100%' }}*/}
                            {/*/>*/}

                            <AutoComplete
                                placeholder="查询的代币地址"
                                value={tokenAddress}
                                onChange={handleTokenAddressChange}
                                // style={{ width: '100%', marginLeft: '20px', marginRight: '20px' }}
                                options={
                                    selectedChain
                                        ? Array.from(new Map(
                                            (tokenOptions[selectedChain.chain_name] || []).map(token => [token.address, {
                                                value: token.address,
                                                label: `${token.name} - ${token.address}`,
                                            }])
                                        ).values()) // 使用 Map 去重
                                        : []
                                }
                                filterOption={(inputValue, option) =>
                                    option.label.toLowerCase().includes(inputValue.toLowerCase())
                                }
                            />

                        </Form.Item>
                    </Col>
                    {transferType && transferType.includes('CEX') && (
                        <>
                    <Col span={5}>
                        <Form.Item name="cex_api_key">
                            <Input placeholder="CEX API" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item name="cex_api_secret">
                            <Input placeholder="CEX Secret" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                        </>
                )}
                    {transferType && transferType.includes('DEX') && (
                    <Col span={5}>
                        <Form.Item name="chain_private_key"
                                   rules={[
                                       { required: true, message: '请输入链上私钥' }]
                                       }
                        >
                            <Input placeholder="链上私钥" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    )}

                    {transferType && !transferType.includes('FAST') && (
                    <Col span={5}>
                        <Form.Item
                            name="duration_minutes"
                            rules={[
                                { required: true, message: '请输入执行时间' },
                                {
                                    validator: (_, value) =>
                                        Number.isInteger(+value) && +value > 0
                                            ? Promise.resolve()
                                            : Promise.reject(new Error('时间必须为正整数')),
                                },
                            ]}
                        >
                            <Input placeholder="执行时间(分钟)" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    )}

                    <Col span={4}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%' }}>
                                批量转入
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            <Table
                rowKey="task_id"
                columns={columns}
                dataSource={records}
                loading={loading}
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    showSizeChanger: false,
                    onChange: fetchRecords,
                }}
            />

            <Modal
                title="批量转入详情"
                visible={detailModalVisible}
                onCancel={() => setDetailModalVisible(false)}
                footer={null}
                width={1200} // 设置宽度
            >
                <Table
                    rowKey="account_address"
                    columns={detailColumns}
                    dataSource={detailTransfers}
                    pagination={{
                        current: detailPagination.current,
                        pageSize: detailPagination.pageSize,
                        total: detailPagination.total,
                        showSizeChanger: false,
                        onChange: (page, pageSize) => fetchTransferDetails(selectedTaskId, page, pageSize), // 关键修改
                    }}
                />
            </Modal>
        </Content>
    );
};

export default BatchTransferIn;
